/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const businessModelRevenueChannelDtoSchema = z.object({
  category: z.optional(z.string()),
  channel: z.optional(z.string()),
  pricing: z.optional(z.string()),
  billing: z.optional(z.string()),
  revShare: z.optional(z.string()),
  growthMoM: z.optional(z.string()),
  description: z.optional(z.string()),
});
